module.exports = __webpack_public_path__ + "img/vuesax_register.cfd9ef09.jpg";